import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import { buildValidationRules } from '../utils/fieldUtils'
import SydDateTimeInput from './components/SydDateTimeInput'

function DateTimeFieldEditor ({ field, control, form }) {
  const baseRules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  const rules = {
    ...baseRules,
    validate: {
      ...(baseRules.validate || {}),
      validDateTime: (value) => {
        if (!value || value === '') return true
        // Native datetime-local emits YYYY-MM-DDTHH:mm; allow optional :ss / .sss
        // / tz so values flowing in from initFrom data are also accepted.
        const datetimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:?\d{2})?$/
        if (!datetimeRegex.test(value)) {
          return 'Invalid datetime format.'
        }
        const date = new Date(value)
        if (isNaN(date.getTime())) {
          return 'Invalid datetime.'
        }
        return true
      }
    }
  }

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydDateTimeInput {...hookField} />
        </SydLabel>
      )}
    />
  )
}

DateTimeFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default DateTimeFieldEditor
